import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { Layout } from 'components';
import { BismillahCalligraphy, defaultImage } from 'images';
import {
  device,
  Modal,
} from 'utils';
import '../components/project_details.css';

import ProjectTab from './components/ProjectTabs/ProjectTab';

import { ProjectDetails } from './components';

import { ProjectsActions, DonationsActions } from 'redux/actions';
import ContactModal from '../components/ContactModal';
import Goodies from './components/Goodies/Goodies';
import ProjectUpdates from './components/ProjectUpdates/ProjectUpdates';
import { InformationBlock } from './components/InformationBlock/InformationBlock';
import MoreProjects from './components/MoreProjects/MoreProjects';
import Hadeth from './components/Hadeth/Hadeth';
import ProjectStickyHeader from './components/ProjectStickyHeader/ProjectStickyHeader';
import ShareProject from './components/Share/ShareProject';
import { buildDonationUrl } from './components/utils/utm';

const ProjectWrapper = styled.div`
  .pattern-1-hero {
    z-index: -2;
    object-fit: fill;
    background-image: url('https://cdn.prod.website-files.com/677e8c6239136af36bc65f94/6782d8d4e8901387fcb4dbfe_Pattern%201.png');
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    position: absolute;
    inset: 0% 0% auto;
    overflow: clip;

    @media ${device.allMobile} {
      display: none;
    }
  }
  .pattern-1 {
    z-index: -2;
    position: absolute;
    inset: 0% 0% auto;
    overflow: clip;

    @media ${device.allMobile} {
      display: none;
    }
  }


  .pattern-3 {
    z-index: -3;
    position: absolute;
    inset: auto 0% -100% auto;

    @media ${device.allMobile} {
      display: none;
    }
  }

  overflow: hidden;
  .content-Wrapper {
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    min-width: 0;
  }
  .start-project__component {
    padding: 0 20px;
    h1 {
      font-size: 50px;
      margin: 50px auto;
      max-width: 950px;
      font-weight: bold;
      @media ${device.allMobile} {
        font-size: 25px;
        margin: 15px auto;
      }
      @media ${device.tablet} {
        font-size: 35px;
      }
    }
  }
  .show-more-wrapper {
    position: relative;
    .background {
      position: absolute;
      z-index: -1;
      width: 100%;
      top: -50%;
    }
  }
  .show-more-component {
    display: flex;
    align-items: center;
    @media ${device.allMobile} {
      display: block;
    }
    &__content {
      margin-left: 45px;
      text-align: left;
      @media ${device.allMobile} {
        text-align: center;
        margin-left: 0;
      }
      h2 {
        font-weight: bold;
        font-size: 45px;
        margin: 0;
        @media ${device.allMobile} {
          font-size: 25px;
        }
        @media ${device.laptop} {
          font-size: 32px;
        }
        @media ${device.tablet} {
          font-size: 28px;
        }
      }
      p {
        font-size: 30px;
        @media ${device.allMobile} {
          font-size: 16px;
        }
        @media ${device.laptop} {
          font-size: 20px;
        }
        span {
          display: block;
          a {
            text-decoration: underline;
            &:hover {
              font-weight: bold;
            }
          }
        }
      }
    }
  }
`;

const NotFoundPage = styled.main`
  position: relative;
  min-height: calc(100vh - 180px);
  padding: clamp(48px, 7vw, 96px) 20px 96px;
  overflow: hidden;
  background:
    radial-gradient(circle at 15% 5%, rgba(157, 188, 96, 0.2), transparent 30%),
    linear-gradient(180deg, #fbfcf8 0%, #f4f7ef 100%);

  &::before {
    position: absolute;
    z-index: 0;
    right: -180px;
    bottom: -120px;
    width: min(1050px, 90vw);
    height: 720px;
    background: url('/Pattern.svg') center / contain no-repeat;
    content: '';
    opacity: 0.12;
    pointer-events: none;
  }
`;

const NotFoundContent = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
`;

const NotFoundCard = styled.section`
  display: grid;
  grid-template-columns: minmax(260px, 0.75fr) minmax(0, 1.25fr);
  overflow: hidden;
  border: 1px solid rgba(157, 188, 96, 0.28);
  border-radius: 0 32px 0 32px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 24px 70px rgba(30, 50, 43, 0.12);

  @media ${device.allMobile} {
    grid-template-columns: 1fr;
    border-radius: 0 24px 0 24px;
  }
`;

const ErrorPanel = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 56px 30px;
  overflow: hidden;
  background: #1e322b;

  &::after {
    position: absolute;
    right: -120px;
    bottom: -130px;
    width: 430px;
    height: 360px;
    border: 1px solid rgba(157, 188, 96, 0.32);
    border-radius: 50%;
    content: '';
  }

  @media ${device.allMobile} {
    padding: 32px 20px;
  }
`;

const ErrorCode = styled.div`
  position: relative;
  z-index: 1;
  color: #9dbc60;
  font-family: 'Inter', sans-serif;
  font-size: clamp(72px, 10vw, 120px);
  font-weight: 700;
  letter-spacing: -6px;
  line-height: 0.9;
`;

const ErrorLabel = styled.span`
  position: relative;
  z-index: 1;
  margin-top: 14px;
  color: #ffffff;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
`;

const MessagePanel = styled.div`
  padding: clamp(36px, 6vw, 72px);

  @media ${device.allMobile} {
    padding: 36px 24px 40px;
    text-align: center;
  }
`;

const Calligraphy = styled.img`
  display: block;
  width: 220px;
  max-width: 75%;
  height: auto;
  margin-bottom: 24px;

  @media ${device.allMobile} {
    margin-right: auto;
    margin-left: auto;
  }
`;

const PageStateTitle = styled.h1`
  max-width: 560px;
  margin: 0 0 16px;
  color: #1e322b;
  font-family: 'Inter', sans-serif;
  font-size: clamp(30px, 4vw, 46px);
  font-weight: 700;
  letter-spacing: -0.03em;
  line-height: 1.12;
`;

const PageStateText = styled.p`
  max-width: 590px;
  margin: 0;
  color: #535862;
  font-family: 'Inter', sans-serif;
  font-size: 17px;
  line-height: 27px;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 30px;

  @media ${device.allMobile} {
    justify-content: center;
  }
`;

const PrimaryLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px 22px;
  border: 1px solid #9dbc60;
  border-radius: 0 12px 0 12px;
  background: #9dbc60;
  color: #ffffff !important;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: background 160ms ease, border-color 160ms ease, transform 160ms ease;

  &:hover {
    border-color: #6f8c38;
    background: #6f8c38;
    transform: translateY(-1px);
  }
`;

const SecondaryLink = styled(PrimaryLink)`
  border-color: rgba(30, 50, 43, 0.2);
  background: #ffffff;
  color: #1e322b !important;

  &:hover {
    border-color: #9dbc60;
    background: #f4f7ef;
  }
`;

const Suggestions = styled.section`
  margin-top: 56px;
  padding: 28px 32px 8px;
  border: 1px solid rgba(30, 50, 43, 0.08);
  border-radius: 0 24px 0 24px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 16px 50px rgba(30, 50, 43, 0.07);

  @media ${device.allMobile} {
    margin-top: 32px;
    padding: 22px 10px 16px;
  }
`;

const ProjectNotFound = ({ randomProjects = [] }) => (
  <Layout>
    <NotFoundPage>
      <NotFoundContent>
        <NotFoundCard>
          <ErrorPanel aria-hidden="true">
            <ErrorCode>404</ErrorCode>
            <ErrorLabel>Seite nicht gefunden</ErrorLabel>
          </ErrorPanel>

          <MessagePanel>
            <Calligraphy src={BismillahCalligraphy} alt="Bismillah" />
            <PageStateTitle>
              Dieses Projekt konnten wir nicht finden.
            </PageStateTitle>
            <PageStateText>
              Vielleicht wurde der Link geändert oder das Projekt ist nicht
              mehr verfügbar. Entdecke stattdessen Projekte und Events aus der
              Community.
            </PageStateText>
            <Actions>
              <PrimaryLink to="/projects">Projekte entdecken</PrimaryLink>
              <SecondaryLink to="/events">Events entdecken</SecondaryLink>
            </Actions>
          </MessagePanel>
        </NotFoundCard>

        {randomProjects.length > 0 && (
          <Suggestions>
            <MoreProjects
              randomProjects={randomProjects.slice(0, 3)}
              title="Aktuelle Projekte & Events"
            />
          </Suggestions>
        )}
      </NotFoundContent>
    </NotFoundPage>
  </Layout>
);

ProjectNotFound.propTypes = {
  randomProjects: PropTypes.array,
};

const firstItem = (value) => (Array.isArray(value) ? value[0] : value);

const toUnixTimestamp = (value) => {
  if (!value) return null;
  if (typeof value.unix === 'function') return value.unix();
  return value;
};

const scrollPageToTop = () => {
  const resetScrollPosition = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  resetScrollPosition();
  window.requestAnimationFrame(() => {
    resetScrollPosition();
    window.requestAnimationFrame(resetScrollPosition);
  });
};

const getViewPageProject = (project = {}) => {
  const basicInfo = project.basicInfo || {};
  const projectDescription = project.projectDescription || {};
  const fundingTarget = project.fundingTarget || {};
  const categoryType = project.categoryType || {};
  const media = project.media || {};
  const fundingEndDate = toUnixTimestamp(basicInfo.funding_end_date);
  const eventDate = toUnixTimestamp(basicInfo.event_date);

  return {
    ...project,
    title: basicInfo.title || project.title,
    subtitle: basicInfo.subtitle || project.subtitle,
    description:
      basicInfo.description ||
      projectDescription.description ||
      project.description,
    url: basicInfo.url || project.url,
    event_location: basicInfo.event_location || project.event_location,
    funding_days: basicInfo.funding_days || project.funding_days,
    days_left: basicInfo.funding_days || project.days_left,
    goal: fundingTarget.goal || project.goal,
    final_goal: fundingTarget.final_goal || project.final_goal,
    is_ticketable:
      fundingTarget.is_ticketable ?? project.is_ticketable ?? false,
    donation_receipts_possible:
      project.donation_receipts_possible ?? fundingTarget.donation_receipts_possible ??
      project.donation_receipts_possible,
    category_id: categoryType.category_id || project.category_id,
    project_type: categoryType.project_type || project.project_type,
    city: categoryType.city || project.city,
    country: categoryType.country || project.country,
    learned_about: categoryType.learned_about || project.learned_about,
    faq: projectDescription.faq || project.faq || [],
    video: media.video || project.video,
    banner: firstItem(media.banner) || project.banner,
    outer_image: firstItem(media.outer_image) || project.outer_image,
    mobile_image: firstItem(media.mobile_image) || project.mobile_image,
    images: media.images || project.images || [],
    mobile_array_images:
      media.mobile_array_images || project.mobile_array_images || [],
    support_documents: project.supportDocuments || project.support_documents,
    funding_start_date: project.funding_start_date || project.created_at,
    funding_end_date: project.funding_end_date || fundingEndDate,
    event_date: project.event_date || eventDate,
    donations_sum: project.donations_sum || 0,
    donations_count: project.donations_count || 0,
  };
};

const getProjectForPage = (project, isViewPage) =>
  isViewPage ? getViewPageProject(project) : project;

const getProjectImages = (project, isViewPage) => {
  if (!project) return [];

  const images = Array.isArray(project.images) ? [...project.images] : [];
  const hasYouTubeVideo =
    project.video &&
    (project.video.startsWith('https://www.youtube.com') ||
      project.video.startsWith('https://youtu'));

  if (hasYouTubeVideo) {
    images.unshift(project.video);
  }

  if (!images.length && isViewPage) {
    return new Array(7).fill(defaultImage);
  }

  return images;
};

export class ProjectPageTest extends Component {
  componentDidMount() {
    const {
      match: {
        params: { url, id },
      },
      location,
      showProject,
      project,
      updateDraft,

    } = this.props;

    scrollPageToTop();

    const isViewPage = location.pathname.startsWith('/view');
    if (window.fbq) {
      window.fbq('track', 'ViewContent', {
        content_name: 'Project Page',
        project_name: project?.title,
        project_type: project?.project_type,
        final_goal: project?.final_goal,
        city: project?.city,
        goal: project?.goal,
      });
    }
    if (isViewPage) {
      if (!(project && project.id === id)) {
        updateDraft(id, {}, undefined, undefined, true);
      }
    } else if (url) {
      showProject(url);
      this.setState({ url });
    }
  }

  componentDidUpdate(prevProps) {
    const previousProjectKey =
      prevProps.match.params.url || prevProps.match.params.id;
    const currentProjectKey =
      this.props.match.params.url || this.props.match.params.id;

    const projectChanged = previousProjectKey !== currentProjectKey;
    const newProjectFinishedLoading = prevProps.loading && !this.props.loading;

    if (projectChanged || newProjectFinishedLoading) {
      scrollPageToTop();
    }

    const projectErrors = this.props.errors?.errors;
    const hasProjectLoadError = Array.isArray(projectErrors)
      ? projectErrors.length > 0
      : Boolean(projectErrors);

    if (
      !projectChanged &&
      !this.props.loading &&
      !this.props.project?.id &&
      hasProjectLoadError &&
      !this.state.recommendationsRequested
    ) {
      this.setState({ recommendationsRequested: true }, () => {
        this.props.getRandomProjects();
      });
    }
  }

  state = {
    url: null,
    rewardsUpper: [],
    rewardsExist: false,
    showModal: false,
    recommendationsRequested: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.url && prevState.url !== nextProps.match.params.url) {
      nextProps.showProject(nextProps.match.params.url);
      return {
        url: nextProps.match.params.url,
        recommendationsRequested: false,
      };
    }
    return null;
  }


  static propTypes = {
    showProject: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    updateDraft: PropTypes.func.isRequired,
    updates: PropTypes.array.isRequired,
    loadingDonations: PropTypes.bool.isRequired,
    getProjectDonations: PropTypes.func.isRequired,
    donations: PropTypes.object.isRequired,
    randomProjects: PropTypes.array.isRequired,
    getRandomProjects: PropTypes.func.isRequired,
  };

  setRewardsExist = (rewardsExist) => {
    this.setState({ rewardsExist });
  };

  setRewardsUpper = (rewardsUpper) => {
    this.setState({ rewardsUpper });
  }

  handelCloseModal = () => {
    this.setState({ showModal: false });
    document.body.style.overflowY = 'unset';
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
    document.body.style.overflowY = 'hidden';
  };

  render() {
    const {
      project,
      updates,
      loadingDonations,
      getProjectDonations,
      donations,
      randomProjects,
      match: {
        params: { url },
      },
      location,
      errors,
    } = this.props;

    const isViewPage = location.pathname.startsWith('/view');
    const displayProject = getProjectForPage(project, isViewPage);
    const projectImages = getProjectImages(displayProject, isViewPage);
    const projectDonations = Number(displayProject.donations_sum || 0);
    const projectSupporters = Number(displayProject.donations_count || 0);
    const projectDays = Number(displayProject.days_left || 0);

    const projectErrors = errors?.errors;
    const hasProjectLoadError = Array.isArray(projectErrors)
      ? projectErrors.length > 0
      : Boolean(projectErrors);

    if (!displayProject.id && hasProjectLoadError) {
      return <ProjectNotFound randomProjects={randomProjects} />;
    }

    if (!displayProject.id) {
      return null;
    }

    return (
      <>
        <ContactModal />

        <ProjectWrapper>
          <>
            <img
              src="https://cdn.prod.website-files.com/677e8c6239136af36bc65f94/69613dbf58136fb503ebac61_transparent.svg"
              loading="lazy"
              alt=""
              className="pattern-1-hero"
            />
            <Layout container={true}>
              <ProjectStickyHeader
                isEvent={displayProject.is_ticketable}
                rewardsUpper={this.state.rewardsUpper}
                projectDonations={projectDonations}
                project={displayProject}
                title={displayProject.title}
                subTitle={displayProject.subtitle}
                supportersText={projectSupporters}
                daysLeftText={projectDays}
                onShareClick={this.handelShowModal}
                onSupportClick={() => {

                  if(displayProject.is_ticketable){
                      const targetElement =
                        document.getElementById('rewards-section');

                      if (!targetElement) return;

                      window.scrollTo({
                        top: targetElement.offsetTop - 100,
                        behavior: 'smooth',
                      });
                  }else{
                    this.props.history.push(
                      buildDonationUrl({
                        projectId: displayProject.id,

                        donationValue: '30,00',
                      })
                    );
                  }

                }}
                triggerOffset={50}
              />

              <Modal
                showModal={this.state.showModal}
                handelCloseModal={this.handelCloseModal}
              >
                <ShareProject
                  subtitle={displayProject.subtitle}
                  title={displayProject.title}
                  banner={displayProject.banner}
                />
              </Modal>

              <div>
                <ProjectDetails
                  projectUrl={url}
                  projectId={displayProject.id}
                  loadingDonations={loadingDonations}
                  project={displayProject}
                  getProjectDonations={getProjectDonations}
                  donations={donations}
                  projectStatus={displayProject.status}
                  projectDescription={displayProject.description}
                  projectDonations={projectDonations}
                  projectSupporters={projectSupporters}
                  projectDays={projectDays}
                  projectImages={projectImages}
                  projectGoal={displayProject.goal && Number(displayProject.goal)}
                  projectFinalGoal={
                    displayProject.final_goal &&
                    Number(displayProject.final_goal)
                  }
                  isViewPage={isViewPage}
                  banner={displayProject && displayProject.banner}
                  title={displayProject.title}
                  subtitle={displayProject.subtitle}
                  rewardsUpper={this.state.rewardsUpper}
                  rewardsExist={this.state.rewardsExist}
                />


                {/* <Tabs /> */}
                {project && (
                  <ProjectTab
                    {...this.props}
                    project={displayProject}
                    isViewPage={isViewPage}
                    updates={updates}
                    loadingDonations={loadingDonations}
                    projectId={displayProject.id}
                    getProjectDonations={getProjectDonations}
                    donations={donations}
                  />
                )}

                {displayProject.id && (
                  <Goodies
                    setRewardsUpper={this.setRewardsUpper}
                    projectStatus={displayProject.status}
                    projectId={displayProject.id}
                    setRewardsExist={this.setRewardsExist}
                    isTicketable={displayProject.is_ticketable}
                    isPreview={isViewPage}
                    previewRewards={
                      isViewPage ? displayProject.rewards : undefined
                    }
                  />
                )}

                {!isViewPage && updates.length > 0 && (
                  <ProjectUpdates
                    project={displayProject}
                    updates={[...updates]}
                    key={Date.now()}
                  />
                )}

                {!isViewPage && (
                  <>
                    <InformationBlock />

                    <MoreProjects
                      randomProjects={randomProjects}
                      isTicketable={displayProject.is_ticketable}
                    />

                    <Hadeth />
                  </>
                )}

              </div>
            </Layout>
          </>
        </ProjectWrapper>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { updates, project, loading, errors, randomProjects } = state.projects;
  const {
    loading: loadingDonations,
    errors: errorsDonations,
    donations,
  } = state.donations;

  return {
    project,
    updates,
    loading,
    errors,
    donations,
    loadingDonations,
    errorsDonations,
    randomProjects,
  };
};

const mapDispatchToProps = (dispatch) => ({
  showProject: (url) => dispatch(ProjectsActions.showProject(url)),
  updateDraft: (id, project) =>
    dispatch(ProjectsActions.updateDraft(id, project)),
  getProjectDonations: (projectId, perPage, page) =>
    dispatch(DonationsActions.getProjectDonations(projectId, perPage, page)),
  getRandomProjects: () => dispatch(ProjectsActions.getRandomProjects()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPageTest);
